// Feature flags for MonthlyPops.com
// Flip SHOP_ENABLED to true when you're ready to sell products on the site again.
// When true: Shop page + High-End showcase + Collections grid + Shop/Collections nav all return.
export const SHOP_ENABLED = false;
